export const roundNumber = (number) => Math.round(number * 100) / 100;
